<template>
    <DashView>
        <div class="container-fluid pt-4 px-4 pb-5 mb-5">
            <div class="row g-4">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                            <div class="row">
                    <div class="col-md-12">
                    <!-- Debut Filtres -->
                        <div class="d-flex justify-content-center float-right">
                            <form class="row g-1" @submit.prevent="getFactures">                     
                                <div class="col-md-4">
                                    <label for="dateBegin" class="form-label">Début</label>
                                    <input type="date" v-model="dateBegin" class="form-control" id="dateBegin" required>
                                </div>
                                <div class="col-md-4">
                                    <label for="dateEnd" class="form-label">Fin</label>
                                    <input type="date" v-model="dateEnd" class="form-control" id="dateEnd" required>
                                </div>
                                <div class="col-md-4 align-self-end">
                                    <button type="submit" @click="getFactures" class="btn btn-primary">Rechercher</button>
                                </div>
                            </form>
                        </div>
                    <!-- Fin Filtre -->
                </div>
                </div>
                        <div class="card-body">
                            <h3>Factures <span class="badge bgbadge">{{factures.length}}</span> </h3>
                            <div class="table-responsive">
                                <template v-if="factures.length>0">  
                                    <div class="table-wrapper">
                                        <table class="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th>No Facture</th>
                                                <th>Séquence</th>
                                                <th>No Patient</th>
                                                <th>Patient</th>
                                                <th>Total</th>
                                                <th>balance</th>
                                                <th>Statut</th>
                                                <th>Date</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody class="mb-5 pb-5">
                                            <tr v-for="(facture,key) in factures" :key="key">
                                                    <td><router-link :to="{ name: 'payment', params: { facture: facture.number } }" title="Voir">{{facture.number}}</router-link></td>
                                                    <td>{{facture.sequence}}</td>
                                                    <td>{{facture.code_dossier}}</td>
                                                    <td>{{facture.nom_patient}} {{ facture.prenom_patient }}</td>
                                                    <td>{{facture.totalApayer}} {{ facture.indice_devise }}</td>
                                                    <td>{{ facture.balance }} {{ facture.indice_devise }}</td>
                                                    <td>{{facture.status_facture == 1 ? 'En attente' : (facture.status_facture == 2 ? 'payée' : 'annulée')}}
</td>
                                                    <td :title="facture.facture_date">{{ formatDate(facture.facture_date) }}</td>
                                                   <!--  <td>{{transaction.methode}}</td>
                                                    <td>{{transaction.status_transaction==1?'Pending':'Cancel'}}</td>
                                                    <td>{{transaction.reference}}</td> -->
                                                    <td ><router-link :to="{ name: 'payment', params: { facture: facture.number } }" title="Voir"><i class="fa fa-eye"></i></router-link></td>
                                                </tr> 
                                        </tbody>
                                    </table>
                                    </div>
                                    
                                </template>
                                <template v-if="factures.length==0">
                                    <div class="modal-preloader">
                                        <div class="">Aucune donnée!!</div>
                                    </div>
                                </template>
                                <!-- <template v-else>
                                    <div class="modal-preloader">
                                        <div class="spinner"></div>
                                    </div>
                                </template> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </DashView>
</template>
<script>
import DashView from "@/components/DashView.vue"
import axios from 'axios'
  import $ from 'jquery';
  const base_url=process.env.VUE_APP_API_URL;
export default {
    name:"Factures",
    components:{
        DashView
    },
    data(){
        const getFormattedDate = (timeZone) => {
      const newDate = new Date();
      const options = { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' };
      const formattedDate = newDate.toLocaleDateString('en-US', options);
      const [month, day, year] = formattedDate.split('/');
      return `${year}-${month}-${day}`;
    };
      return{
          factures:[],
          dateBegin:getFormattedDate('America/Port-au-Prince'),
          dateEnd:getFormattedDate('America/Port-au-Prince'),
          info_groupe:[],
          accessToken:JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
      }
    },
    created(){
        // (JSON.parse(localStorage.getItem('user_zgc')).code_role)>3 ? this.$router.push('all-vente'):true;
        // const accessToken = JSON.parse(localStorage.getItem('user_zgc')).token ?? '';
        axios.get(`${base_url}/all_facture`,{
                    headers:{
                            Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
              .then((response)=>{
                  console.log(response);
                  if(response.data.Factures){
                      this.factures = response.data.Factures;
                  }
                  
                  
              })
              .catch((error)=>{
                console.log(error?.response?.status);
                if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#openModalNoAccess').trigger('click');
                }
                else {
                // Gérer d'autres erreurs ici
                console.log('Une erreur est survenue!');
                console.log('Autre erreur:', error);
                }
              });
    },
    methods:{
        formatDate(dateString) {
            const date = new Date(dateString);
            const day = ('0' + date.getDate()).slice(-2);
            const month = ('0' + (date.getMonth() + 1)).slice(-2);
            const year = date.getFullYear();
            const hours = ('0' + date.getHours()).slice(-2);
            const minutes = ('0' + date.getMinutes()).slice(-2);
            const seconds = ('0' + date.getSeconds()).slice(-2);

            return `${day}-${month}-${year}`;
        },
        redirectTo(path) {
            this.$router.push(path);
            setTimeout(function() {
            location.reload();
            }, 1);
        },
        getFactures(){
              console.log(this.dateBegin,this.dateEnd);
              this.factures=[];
              if(this.dateBegin && this.dateEnd){
                  axios.get(`${base_url}/all_facture?datedebut=${this.dateBegin}&&datefin=${this.dateEnd}`,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                  .then((response)=>{
                    //   console.log(response.data);
                      if(response?.data?.Factures){
                          this.factures=response?.data?.Factures ?? [];
                      }
                  })
                  .catch((error)=>{
                      console.log('Une erreur est survenue!');
                      console.error(error);
                  })
              }
        }

    }
}
</script>
<style lang="">
    
</style>